export const APP_ID = '2015199145383303';
export const PAGE_ID = '1754274684887439';
export const REF = '79da2ad719b7110df9c9f1dfc37d8de17e498dfb7afc530447';
